import React, { useEffect, useMemo } from "react";
import { useTimer } from "react-timer-hook";
import { useSelector } from "react-redux";
import { examStartedSelector } from "../../../redux/features/timer/timerSelectors";
import { updateEnd } from "../../../redux/features/timer/timerSlice";
import { useDispatch } from "react-redux";
import { store } from "../../../redux/store";
import { submitExam } from "../../../redux/activityAsyncAction";
import { useRef } from "react";
// import { useHistory } from "react-router";
// import { getExpiryTime } from "../../../utils/utils";

const Timer = () => {
  const examStarted = useSelector(examStartedSelector);
  const dispatch = useDispatch();
  let restartRef = useRef(false);
  // const history = useHistory();
  const duration = useSelector((state) => state.timer.times.expiryTime);
  console.log();
  //getting expiry date
  const expiryTimestamp = useMemo(() => {
    const {
      timer: {
        timeCount,
        // times: { startTime },
      },
    } = store.getState();
    const time = new Date();
    // const startTimeInSec = startTime
    //   ? Math.floor((Date.now() - startTime) / 1000)
    //   : 0;
    //time.setSeconds(time.getSeconds() + duration / 1000 - startTimeInSec);
    time.setSeconds(time.getSeconds() + duration / 1000 - timeCount);
    // time.setSeconds(time.getSeconds() + duration / 1000);
    return time;
  }, [duration]);

  const { seconds, minutes, hours, start, restart } = useTimer({
    expiryTimestamp,
    autoStart: false,
    onExpire: () => {
      dispatch(updateEnd());
      dispatch(submitExam());
      console.info("onExpire called");
    },
  });

  useEffect(() => {
    if (examStarted) {
      if (restartRef.current) {
        restart(expiryTimestamp, true);
        console.log("restart due to deducted time");
      }
      restartRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiryTimestamp, examStarted]);

  useEffect(() => {
    if (examStarted) {
      start();
      console.log("start has been clicked");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [examStarted]);

  return (
    <div className="d-flex justify-content-end fw-bold pe-1 h5">
      <span>&nbsp;{hours}&nbsp;</span> : <span>&nbsp;{minutes}&nbsp;</span> :
      <span>&nbsp;{seconds}</span>
    </div>
  );
};

export default Timer;
